import cn from "classnames";
import DefaultTemplate from "./default";

class SidebaredBigModal extends DefaultTemplate {
    state = {
        isLoading: true,
        sidebarOpened: true,
        showPanel: true,
    };

    calcCname = () => {
        const { windowMod } = this.props;
        return cn({
            "modal__window modal-window modal-window--lg modal-window--asided asided-modal": true,
            "asided-modal--collapsed": !this.state.sidebarOpened,
            [`modal-window--${windowMod}`]: !!windowMod,
        });
    };
}

export default SidebaredBigModal;
